(() => {
  if (window.__legacySportwearProductCardInit) return;
  window.__legacySportwearProductCardInit = true;

  function getCartAddEndpoint() {
    const base = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    return base.endsWith('.js') ? base : `${base}.js`;
  }

  function isAddToCartForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    const action = (form.getAttribute('action') || '').toLowerCase();
    if (action.includes('/cart/add')) return true;
    // Shopify form helpers sometimes omit action in markup; fallback to presence of variant id field.
    return !!form.querySelector('input[name="id"]');
  }

  async function handleAddToCartSubmit(form) {
    const submitBtn = form.querySelector('[type="submit"]');
    const prevDisabled = submitBtn ? submitBtn.disabled : false;

    try {
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-busy', 'true');
      }

      const formData = new FormData(form);
      const res = await fetch(getCartAddEndpoint(), {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!res.ok) {
        let err;
        try {
          err = await res.json();
        } catch (_) {
          err = null;
        }
        throw new Error(err && err.description ? err.description : 'Error adding to cart');
      }

      // Open the existing drawer (it refreshes cart + counts internally)
      if (typeof window.openCartDrawer === 'function') {
        window.openCartDrawer();
      } else {
        // Fallback: update counts at least
        fetch('/cart.js')
          .then((r) => r.json())
          .then((cart) => {
            const badge = document.querySelector('[data-cart-count-badge]');
            if (badge) badge.textContent = cart.item_count;
            const headerCount = document.querySelector('[data-cart-count]');
            if (headerCount) headerCount.textContent = cart.item_count;
          })
          .catch(() => {});
      }
    } finally {
      if (submitBtn) {
        submitBtn.disabled = prevDisabled;
        submitBtn.removeAttribute('aria-busy');
      }
    }
  }

  function setCardLink(card, url) {
    const link = card.querySelector('[data-product-card-link]');
    if (!link) return;
    if (!link.dataset.defaultHref) link.dataset.defaultHref = link.href;
    link.href = url;
  }

  function updateCardImage(card, src, srcset) {
    const img = card.querySelector('[data-product-card-image]');
    if (!img) return;

    if (!img.dataset.defaultSrc) {
      img.dataset.defaultSrc = img.getAttribute('src') || '';
      img.dataset.defaultSrcset = img.getAttribute('srcset') || '';
    }

    if (src) img.setAttribute('src', src);
    if (srcset) img.setAttribute('srcset', srcset);
  }

  function restoreCardImage(card) {
    const img = card.querySelector('[data-product-card-image]');
    if (!img || !img.dataset.defaultSrc) return;
    img.setAttribute('src', img.dataset.defaultSrc);
    img.setAttribute('srcset', img.dataset.defaultSrcset || '');
  }

  // Event delegation: clicks
  document.addEventListener('click', (event) => {
    const swatchBtn = event.target.closest('.product-card__variant-swatch');
    if (swatchBtn) {
      event.preventDefault();
      event.stopPropagation();
      const variantUrl = swatchBtn.getAttribute('data-variant-url');
      if (variantUrl) window.location.href = variantUrl;
    }
  });

  // Event delegation: hover-to-swap image + keep link in sync
  document.addEventListener('mouseover', (event) => {
    const swatchBtn = event.target.closest('.product-card__variant-swatch');
    if (!swatchBtn) return;

    const card = swatchBtn.closest('.product-card');
    if (!card) return;

    const variantUrl = swatchBtn.getAttribute('data-variant-url') || '';
    const imgSrc = swatchBtn.getAttribute('data-variant-image-src') || '';
    const imgSrcset = swatchBtn.getAttribute('data-variant-image-srcset') || '';

    if (imgSrc) updateCardImage(card, imgSrc, imgSrcset);
    if (variantUrl) setCardLink(card, variantUrl);
  });

  document.addEventListener('mouseout', (event) => {
    const leavingSwatch = event.target.closest('.product-card__variant-swatch');
    if (!leavingSwatch) return;

    const card = leavingSwatch.closest('.product-card');
    if (!card) return;

    const related = event.relatedTarget;
    const stillInsideVariants = related && related.closest && related.closest('.product-card__variants');
    if (stillInsideVariants) return;

    restoreCardImage(card);

    const link = card.querySelector('[data-product-card-link]');
    if (link && link.dataset.defaultHref) {
      link.href = link.dataset.defaultHref;
    } else if (link) {
      link.dataset.defaultHref = link.href;
    }
  });

  // ── Mobile swipe to cycle color variant images ──────────────────────
  (function () {
    let touchStartX = 0;
    let touchStartY = 0;
    const SWIPE_THRESHOLD = 40;

    function getSwipeData(wrapper) {
      const raw = wrapper.dataset.swipeImages;
      if (!raw) return null;
      return {
        urls: raw.split('|'),
        ids: (wrapper.dataset.swipeIds || '').split('|'),
        alts: (wrapper.dataset.swipeAlts || '').split('|'),
        index: parseInt(wrapper.dataset.swipeIndex || '0', 10),
      };
    }

    function applySwipeFrame(wrapper, data) {
      const img = wrapper.querySelector('[data-product-card-image]');
      if (img) {
        const url = data.urls[data.index];
        img.src = url;
        img.srcset = url;
        img.alt = data.alts[data.index] || '';
      }
      wrapper.dataset.swipeIndex = data.index;

      // Update dots
      const dots = wrapper.querySelectorAll('.product-card__swipe-dot');
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === data.index));

      // Update card link with variant id
      const card = wrapper.closest('.product-card');
      if (card && data.ids[data.index]) {
        const link = card.querySelector('[data-product-card-link]');
        if (link) {
          if (!link.dataset.defaultHref) link.dataset.defaultHref = link.href;
          const baseUrl = link.dataset.defaultHref.split('?')[0];
          link.href = baseUrl + '?variant=' + data.ids[data.index];
        }
      }
    }

    document.addEventListener('touchstart', (e) => {
      const wrapper = e.target.closest('[data-swipe-images]');
      if (!wrapper) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });

    document.addEventListener('touchend', (e) => {
      const wrapper = e.target.closest('[data-swipe-images]');
      if (!wrapper) return;
      const dx = e.changedTouches[0].clientX - touchStartX;
      const dy = e.changedTouches[0].clientY - touchStartY;
      // Ignore vertical scrolls
      if (Math.abs(dy) > Math.abs(dx)) return;
      if (Math.abs(dx) < SWIPE_THRESHOLD) return;

      const data = getSwipeData(wrapper);
      if (!data || data.urls.length < 2) return;

      if (dx < 0) {
        // swipe left → next
        data.index = (data.index + 1) % data.urls.length;
      } else {
        // swipe right → prev
        data.index = (data.index - 1 + data.urls.length) % data.urls.length;
      }
      applySwipeFrame(wrapper, data);
    }, { passive: true });
  })();

  // Initialize defaults + cart count on first load
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-product-card-link]').forEach((link) => {
      if (!link.dataset.defaultHref) link.dataset.defaultHref = link.href;
    });
  });

  // Intercept add-to-cart to avoid redirecting to /cart (use cart drawer instead)
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!isAddToCartForm(form)) return;
    event.preventDefault();
    handleAddToCartSubmit(form).catch((err) => {
      console.error(err);
    });
  });
})();
